import { render, staticRenderFns } from "./NavigationBtn.vue?vue&type=template&id=5eafa246&"
import script from "./NavigationBtn.vue?vue&type=script&lang=js&"
export * from "./NavigationBtn.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBtn.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports